import React from 'react'
import { ChevronRight } from 'lucide-react'
import styles from './BreadcrumbSeparator.module.scss'

interface BreadcrumbSeparatorProps {
  className?: never
}

export const BreadcrumbSeparator: React.FC<BreadcrumbSeparatorProps> = () => (
  <ChevronRight className={styles.separator} />
)
